import { formatString } from '../../../assets/js/utils/formatString';

function getHeadingsMapping(
    activeStepName,
    resourceTexts,
    productTitle,
    nrOfSelectedOrganizations,
    conditionalProductsType,
) {
    const {
        calculationSchoolSelectionMainHeading,
        calculationTitle,
        calculationMainHeadingSingular,
        calculationMainHeadingPlural,
        calculationConditionalMainHeadingAllOf,
        calculationConditionalMainHeadingOneOf,
        calculationConditionalTitle,
        calculationFinishedTitle,
        calculationFinishedMainHeading,
        calculationTechnicalProblemMainHeading,
    } = resourceTexts;

    switch (activeStepName) {
        case 'CalculationSchoolSelection':
            return {
                title: formatString(calculationTitle, [productTitle]),
                mainHeading: calculationSchoolSelectionMainHeading,
            };
        case 'CalculationCalculate':
        case 'CalculationResult':
            return {
                title: formatString(calculationTitle, [productTitle]),
                mainHeading:
                    nrOfSelectedOrganizations > 1
                        ? formatString(calculationMainHeadingPlural, [nrOfSelectedOrganizations])
                        : formatString(calculationMainHeadingSingular, [nrOfSelectedOrganizations]),
            };
        case 'CalculationTechnicalProblem':
            return {
                title: formatString(calculationTitle, [productTitle]),
                mainHeading: calculationTechnicalProblemMainHeading,
            };
        case 'CalculationConditional':
            let conditionalHeading = '';
            if (conditionalProductsType === 'AllOf') {
                conditionalHeading = calculationConditionalMainHeadingAllOf;
            } else {
                conditionalHeading = calculationConditionalMainHeadingOneOf;
            }

            return {
                title: formatString(calculationConditionalTitle, [productTitle]),
                mainHeading: conditionalHeading,
            };
        case 'CalculationFinished':
            return {
                title: formatString(calculationFinishedTitle, [productTitle]),
                mainHeading: calculationFinishedMainHeading,
            };
        default:
            return {};
    }
}

export { getHeadingsMapping };
